import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { handleHttpError } from '../../../common/httpErrorHandler';
import { GeraeteApiService } from '../../api/services';
import { GeraeteActions } from './geraete.actions';

@Injectable()
export class GeraeteEffects {
  loadGeraete$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        GeraeteActions.loadGeraete,
      ),
      switchMap(() => {
        return this.api$.getAllGeraete$Json().pipe(
          map((geraete) => {
            const sortedGeraete = [...geraete ].sort(
                (a, b) => {
                    const numA = Number(a.seriennummer);
                    const numB = Number(b.seriennummer);
                    return numA - numB;
                }
            )
            return GeraeteActions.loadGeraeteSuccess({ geraete : sortedGeraete})
          }
        ),
          catchError((error) =>
            of(GeraeteActions.loadGeraeteFailure({ error })),
          ),
        );
      }),
    );
  });

  loadGeraeteFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GeraeteActions.loadGeraeteFailure),
        tap(async ({ error }) => {
          console.error(error);
          await handleHttpError(
            error,
            this.toastCntr,
            'Beim Laden der Seriennummern ist ein Fehler aufgetreten.',
          );
        }),
      );
    },
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private readonly api$: GeraeteApiService,
    private readonly toastCntr: ToastController,
  ) {}
}
